export default {
    // A
    aiAssistantTrainingData: 'AI Assistant training data',
    attachFile: 'Attach file',
    attachJsonlFileWithTrainingData: 'Attach .jsonl file with training data',

    // D
    describeAllTrainingOptions: 'Describe all training options that will be used in the Studio to train a fine-tuned model.',

    // E
    exampleStructure: {
        title: 'Each example should have this structure:',
        prmptStart: 'PRMPT_START',
        yourPromptText: 'your prompt text',
        prmptFinish: 'PRMPT_FINISH',
        rspnsStart: 'RSPNS_START',
        yourResponseText: 'your response text',
        rspnsFinish: 'RSPNS_FINISH',
        trainDataSeparator: 'TRAIN_DATA_SEPARATOR',
    },

    // F
    trainingFileName: 'File: {trainingFileName}',

    // G
    generateJsonl: 'Generate .jsonl',

    // P
    provideDataToCreateTrainingFile: 'Provide data to create a training file',

    // R
    replaceFile: 'Replace file',
}
